<template>
  <router-view></router-view>
  <CustomAlert v-if="alertInfo.show" :title="alertInfo.title" :msg="alertInfo.msg" :type="alertInfo.type" :sCb="alertInfo.sCb" :fCb="alertInfo.fCb"></CustomAlert>
  <!-- <HelloWorld msg="Welcome to Your Vue.js + TypeScript App" /> -->
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import CustomAlert from "@/components/alert/CustomAlert.vue";
const store = useStore();
const alertInfo = store.getters.getAlert;
const alert = (data: any) => {
  store.commit("alert", { title: data.title, msg: data.msg, sCb: data.sCb });
};
const confirm = (data: any) => {
  store.commit("confirm", { title: data.title, msg: data.msg, sCb: data.sCb, fCb: data.fCb });
};
window.customAlert = alert;
window.customConfirm = confirm;
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
